import { apiGet, apiPost } from '.';
import {
  BareFeedTemplate,
  FeedTemplate,
  BareFeedPage,
  FeedPage,
  BareFeedArea,
  FeedArea,
} from '../../../shared/types/feedTemplate';
import { Property } from '../../../shared/types/property';
import { BareContentTemplateLegacy } from '../../../shared/types/contentTemplate';
import { VenueTemplate } from '@go-shared/types/venueTemplate';
import { DailyProgramEvent } from '@go-shared/types/dailyProgram';

export async function getFeedTemplatesByProperty(propertyId: string): Promise<BareFeedTemplate[]> {
  return apiGet(`/property/${propertyId}/feed-template`);
}

export async function exportFeed(
  sailingId: string,
  sailingDayId: string,
  options: { legacy: boolean; lang?: string; hideBackground: boolean } = {
    legacy: false,
    hideBackground: false,
  },
  feedSlotNumber: number
): Promise<string[]> {
  return apiPost(`/export/sailing/${sailingId}/day/${sailingDayId}/feed`, {
    options,
    feedSlotNumber,
  });
}

function populateFeedArea(
  bareArea: BareFeedArea,
  contentTemplates: BareContentTemplateLegacy[]
): FeedArea {
  let content = bareArea.content
    ? contentTemplates.find(c => c._id === bareArea.content)
    : undefined;

  return {
    ...bareArea,
    content,
  };
}

function populateFeedPage(
  barePage: BareFeedPage,
  contentTemplates: BareContentTemplateLegacy[]
): FeedPage {
  return {
    ...barePage,
    areas: barePage.areas.map(bareArea => populateFeedArea(bareArea, contentTemplates)),
  };
}

export function populate(
  bareFeedTemplate: BareFeedTemplate,
  property: Property,
  contentTemplates: BareContentTemplateLegacy[]
): FeedTemplate {
  return {
    ...bareFeedTemplate,
    property,
    pages: bareFeedTemplate.pages.map(barePage => populateFeedPage(barePage, contentTemplates)),
  };
}

function bareFeedArea(area: FeedArea): BareFeedArea {
  let content = area.content ? area.content._id : undefined;

  return {
    ...area,
    content,
  };
}

function bareFeedPage(page: FeedPage): BareFeedPage {
  return {
    ...page,
    areas: page.areas.map(bareFeedArea),
  };
}

export function bare(feedTemplate: FeedTemplate): BareFeedTemplate {
  return {
    ...feedTemplate,
    property: feedTemplate.property._id,
    pages: feedTemplate.pages.map(bareFeedPage),
  };
}

export const buildEventContentTemplateFromEvent = (
  event: DailyProgramEvent,
  property: Property,
  generateContent: (event: DailyProgramEvent) => string
): BareContentTemplateLegacy => {
  return {
    _id: event.id,
    content: generateContent(event),
    name: event.title,
    property: property._id,
    params: {
      eventId: event.templateId,
    },
  };
};

export const buildVenueContentTemplateFromVenue = (
  venue: VenueTemplate,
  property: Property,
  generateContent: (venue: VenueTemplate) => string
): BareContentTemplateLegacy => {
  return {
    _id: venue._id,
    content: generateContent(venue),
    name: venue.name,
    property: property._id,
    params: {
      venueId: venue._id,
    },
  };
};
